export const DELETE_MERCHANT_APPLICATION = gql`
    mutation deleteMerchantApplication($applicationId: Int!) {
        deleteMerchantApplication(applicationId: $applicationId)
    }
`;
